import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getRequest, postRequest, putRequest, deleteRequest, tabulatorGet, downloadBlobGet, fetchTextGet } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,PaperClipIcon, CollapseTreeIcon, ExpandTreeIcon, BranchTreeIcon, EnvelopeIcon} from "../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { DateTime } from "luxon";
import UtilContext from '../../components/UtilContext';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import ReactDOMServer from 'react-dom/server';
import * as XLSX from 'xlsx';
import { useFormik } from 'formik';
import { MultiSelect } from 'primereact/multiselect';
import AuthContext from '../../components/AuthContext';
import { showDeactivatedInLists, showInactiveEmployeesInLists } from '../../utils/moduleSettings';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { createDedupedAjaxRequest, extractSafePaginationParams, cleanSorters, parseMaskFilters, safeParse, createSerializedProgressiveRefreshController, buildTabulatorInitialHeaderFilterFromMask, getTabulatorInitialSortUnlessMaskHasSorters } from '../../utils/tabulatorProgressiveLoading';
import { TABULATOR_AUDIT_MIN_ROW_HEIGHT } from '../../utils/tabulatorAuditColumns';
import { dateUserHeaderFilter } from '../../utils/dateUserHeaderFilter';
import { inputOnEnterHeaderFilter } from '../../utils/inputOnEnterHeaderFilter';
import { tabulatorDateUserColumnMinWidth } from '../../utils/tabulatorColumnMinWidth';
import { buildExportQueryStringFromParams, openPrintHtmlWindow, triggerBlobDownload } from '../../utils/serviceTaskExport';
import { xlsxDownloadFilename } from '../../utils/exportExcelNaming';
import { Avatar } from 'primereact/avatar';
import { getTabulatorPersistLayoutEvents } from '../../utils/tabulatorPersistLayout';
import { getPusherChannel } from '../../utils/pusherChannel';
import { useTrainingCompanies } from '../../utils/useTrainingCompanies';
import { normalizeForMatch } from '../../utils/textNormalize';
import { normalizeExclusiveFilterCsv, primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { getTrngSemaforColor, getSemaforColorClass } from '../../utils/moduleSettings';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';
import { toLocalDateString } from '../../utils/previewDateRange';
import {
    computeTrainingSelectionCascade,
    toTrainingSelectionFormValues,
} from '../../utils/trainingSelectionCascade';
import {
    buildEditFormCompanyContactOptions,
    buildEditFormLecturerOptions,
    buildTrainingCardEditFormValues,
    mergeTrainingCardCascadeFormValues,
} from '../../utils/trainingCardEditHydration';

const TRAINING_STATE_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'training.department.name': 'Common.TrainingDepartment',
  'custom_training_name': 'Common.TrainingName',
  'custom_last_training_date': 'Common.LastTraining',
  'custom_next_training_date': 'Common.NextTraining',
  'custom_expiration': 'Common.Expiration',
  'custom_state': 'Common.Status',
  'my_status': 'Common.EmployeeStatus',
  'custom_training_status': 'Common.TrainingStatus',
  'custom_invitation': 'TrainingStateList.Text.Pozvanka',
  'training.type': 'TrainingTypeList.Column.Type',
  'company.name': 'Common.TrainingCompanyShort',
  'custom_company_contact_name': 'Common.Trainer',
  'training.employee.name': 'Common.Column.Responsible',
  'training.description': 'TrainingStateList.Text.Popis_typu_skolenia',
  'description': 'Common.Description',
  'created_at': 'Common.Column.CreatedAt',
  'updated_at': 'Common.Column.UpdatedAt',
  'id': 'Common.TrainingDepartment',
  'employee.name': 'Common.EmployeeName',
  'protocol': 'Common.Protocol',
  'training.interval': 'SummaryEmailOTKList.Column.Interval',
  'machines': 'Common.Machine',
  'custom_lecturer_name': 'Common.Lecturer',
});
export default function TrainingStateList({ preview = null, preview_period = null, preview_segment = null }) {

    const [state, dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies({ includeExcluded: true });
    const { user } = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const { setDialogText, setVisible, openFavoriteDialog, toast, setFastView, setUserMaskFilter, openFilePreview, getDateFormat, getUserColor, getUserInitials, openChosenNotificationPreferences} = useContext(UtilContext);

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const showDeactivated = showDeactivatedInLists(state.module_settings, 'training');
    const showInactiveEmployees = showInactiveEmployeesInLists(state.module_settings);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';

    const [invitationIcon,setInvitationIcon] = useState(true);
    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleInvitation,setVisibleInvitation] = useState(false);
    const [invitationSourceRow, setInvitationSourceRow] = useState(null);
    const [lecturers, setLecturers] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [trainingCardsList, setTrainingCardsList] = useState([]);
    const [loadingInvitationCards, setLoadingInvitationCards] = useState(false);
    const [lecturersFallback, setLecturersFallback] = useState([]);
    const [machines, setMachines] = useState(state.machines || []);
    const [selectedRecord,setSelectedRecord] = useState(null);
    const effectiveLecturers = (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback;

    useEffect(() => {
        const hasLecturers = (state.lecturers || []).length > 0;
        Promise.all([
            getRequest("/api/training_types?minimal=1").then((r) => (r?.data ?? r) || []),
            getRequest("/api/company_contacts?minimal=1&module=training").then((r) => {
                const list = r?.data ?? r ?? [];
                return Array.isArray(list) ? list.filter((c) => c?.module === 'training') : [];
            }),
            hasLecturers ? Promise.resolve(null) : getRequest("/api/lecturers").then((r) => (r?.data ?? r) || []),
        ])
            .then(([types, contacts, lecturersData]) => {
                setTrainingTypesList(types || []);
                setCompanyContactsList(contacts || []);
                if (!hasLecturers && Array.isArray(lecturersData)) setLecturersFallback(lecturersData);
            })
            .catch(() => {});
    }, []);

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);
    const [printValue,setPrintValue] = useState("Zoznam");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({'employee.name':true,'training.department.name':true,custom_training_name:true,custom_last_training_date:true,custom_next_training_date:true,protocol:true,
      custom_expiration:true,custom_state:true,my_status:true,custom_training_status:true,custom_invitation:true,'training.type':true,'training.interval':true,'company.name':true,'machines':true,
      custom_lecturer_name:true,custom_company_contact_name:true,'training.employee.name':true,'training.description':true,description:true, created_at:true, updated_at:true,
    });

    const [maskVisible, setMaskVisible] = useState(false);
const [visibleRecord,setVisibleRecord] = useState(false);
    const [images,setImages] = useState('');

    // training_cards sa nenačítavajú pri stránke – len v dialógu t('TrainingStateList.Text.Vytvorit_pozvanku') pri onShow (tam je MultiSelect Zamestnanci).

    const [updatefileList, setUpdateFileList] = useState([]);
    const updateFileListRef = useRef(null);


    const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const ajaxGenerationRef = useRef(0);
    const sessionQueryActiveRef = useRef(false);
    const submittedSearchValueRef = useRef('');
    const tableBuiltRef = useRef(false);
    const isRestoringRef = useRef(false);
    const maskRestoreDoneRef = useRef(false);
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const progressiveRefresh = useMemo(
      () => createSerializedProgressiveRefreshController({
        getTable,
        completedCacheRef,
        inFlightRef,
        generationRef: ajaxGenerationRef,
        coalesceMs: 50,
        loadingMessage: t('Common.LoadingEllipsis'),
        onBeforeRefresh: () => {
          sessionQueryActiveRef.current = true;
        },
      }),
      [getTable],
    );
    const refreshFromStart = useCallback(() => {
      progressiveRefresh.schedule({ immediate: true });
    }, [progressiveRefresh]);
    // MODEL A: Tabulator Filter/Sort own remote page-1 reloads. Soft controller is only for
    // explicit toolbar/search/pusher/menu actions Tabulator does not own.
    const skipMaskForInit = Boolean(preview || preview_period);
    // Preview CURRENT drilldown header values — UI paint only (not initialHeaderFilter seed).
    const previewHeaderFilters = useMemo(() => {
      if (!preview || preview_period) return [];
      if (preview === 'after') {
        return [
          { field: 'custom_state', value: 'OK,NOK' },
          { field: 'custom_expiration', value: '0-' },
        ];
      }
      if (preview === '15') {
        return [
          { field: 'custom_state', value: 'OK,NOK' },
          { field: 'custom_expiration', value: '15-' },
        ];
      }
      if (preview === '30') {
        return [
          { field: 'custom_state', value: 'OK,NOK' },
          { field: 'custom_expiration', value: '30-' },
        ];
      }
      // others / OK: next_date > today+30 → multi-bucket 45-,60-,61+
      return [
        { field: 'custom_state', value: 'OK' },
        { field: 'custom_expiration', value: '45-,60-,61+' },
      ];
    }, [preview, preview_period]);
    // Preview drilldown: do NOT seed initialHeaderFilter — Tabulator Filter applies it after
    // the first progressive ajax and fires a second identical /paged GET. Population is owned
    // solely by buildRequestParams; header UI is painted silently in tableBuilt.
    const initialHeaderFilter = useMemo(() => {
      if (preview || preview_period) return [];
      return buildTabulatorInitialHeaderFilterFromMask({
        userMaskFilters: state.user_mask_filters,
        maskPage: 'TrainingStateList',
        skipMask: skipMaskForInit,
        normalizeValue: (field, value) => {
          if (value === undefined || value === null || String(value).trim() === '') return null;
          if (field === 'custom_expiration') {
            const normalized = normalizeExclusiveFilterCsv(value, [t('Common.All')]);
            return normalized || null;
          }
          return value;
        },
      });
    }, [state.user_mask_filters, skipMaskForInit, preview, preview_period, t]);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: TRAINING_STATE_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);
    const initialSort = useMemo(() => getTabulatorInitialSortUnlessMaskHasSorters({
      userMaskFilters: state.user_mask_filters,
      maskPage: 'TrainingStateList',
      skipMask: skipMaskForInit,
      defaultSort: [{ column: 'employee.name', dir: 'asc' }],
    }), [state.user_mask_filters, skipMaskForInit]);
    const captureHScroll = useCallback(() => {
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        if (!holder) return;
        savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    }, [getTable]);
    const restoreHScroll = useCallback(() => {
        if (!savedHScrollRef.current.pending) return;
        const table = getTable();
        if (!table) return;
        const holder = table.rowManager?.element;
        const header = table.columnManager?.contentsElement;
        if (!holder) return;
        const left = savedHScrollRef.current.left;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            holder.scrollLeft = left;
            if (header) header.scrollLeft = left;
            savedHScrollRef.current.pending = false;
          });
        });
    }, [getTable]);
    const handlePrint = useReactToPrint({
        onBeforeGetContent: () => {componentRef.current.style.display = "block";},
        onAfterPrint: () => {componentRef.current.style.display = "none";},
        content: () => componentRef.current,
    });

      function matchAny(data, filterParams) {
        //data - the data for the row being filtered
        //filterParams - params object passed to the filter
        //RegExp - modifier "i" - case insensitve
    
        var match = false;
        const regex = RegExp(filterParams.value, 'i');
    
        for (var key in data) {
            if (regex.test(data[key]) === true) {
                match = true;
            }
        }
        return match;
      }

      function searchTable() {
        const normalized = String(searchValue ?? '').trim();
        // Snapshot before restart so stale ajaxRequestFunc closures still read the committed term.
        submittedSearchValueRef.current = normalized;
        setSearchIconColor(normalized === '' ? '' : 'active');
        setVisibleSearch(false);
        captureHScroll();
        sessionQueryActiveRef.current = true;
        refreshFromStart();
      }

      function clearSearch() {
        setSearchIconColor('');
        setSearchValue('');
        submittedSearchValueRef.current = '';
        captureHScroll();
        sessionQueryActiveRef.current = true;
        refreshFromStart();
      }
    
        const accept = () => {
            let rows_to_delete = [];
            rows_to_delete = getTable()?.getSelectedData?.() ?? [];
            rows_to_delete.forEach(element => {
                deleteRequest(`/api/training_records/${element.id}`)
                .then((response) => {
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                }).catch((reason) => {
                    alert(reason);
                    toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
                });
            });
            captureHScroll();
            refreshFromStart();
        }

      function TrainingName(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(rowData?._children) return <div className='training_name'>{rowData.training.name}</div>;
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==parent_array.length-1)return <div className='training_name'>Prvotné školenie</div>;
                    else return <div className='training_name'>{parent_array.length-1-i}. Opakované školenie</div>;
                }
            }
            return <div className='training_name'>{parent._row.data.training.name}</div>;
        }
    } 

    function NameFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='training_name'>{rowData.employee?.name}</div>;
    }

    function employeeHeaderFilter(headerValue, rowValue, rowData, filterParams) {
      if (!headerValue || String(headerValue).trim() === '') return true;
      const name = String(rowData.employee?.name ?? rowValue ?? '').trim();
      return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    } 

      function LastTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].last_training_date).toFormat(dateFmt);
        if(rowData?.last_training_date) return DateTime.fromISO(rowData?.last_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
      }

      function NextTrainingDate(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?._children?.length > 0) return DateTime.fromISO(rowData._children[0].next_training_date).toFormat(dateFmt);
        if(rowData?.next_training_date) return DateTime.fromISO(rowData?.next_training_date).toFormat(dateFmt);
        if(new Date(rowData?.initial_date) > new Date())return <span className='text-blue-600'>{t('Common.Scheduled')}</span>;
        return <span className='text-red-500'>{t('TrainingRecordDetail.Text.Neskoleny')}</span>;
      }

      function StateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        var parent = props.cell.getRow()?.getTreeParent();
        if(parent){
            let parent_array = parent._row.data._children;
            for(let i = 0;i<parent_array.length;i++){
                if(parent_array[i].id == rowData.id){
                    if(i==0){
                        if(parent._row.data?.deactivation_date!=null && parent._row.data?.deactivation_date!=""){
                            return "DEA";
                        }
                        else if(new Date(parent_array[i]?.next_training_date) < new Date()){
                            return "NOK";
                        }
                        else return "OK";
                    }
                    else return "OK";
                }
            }
        }
        if(rowData?.deactivation_date!=null && rowData?.deactivation_date!="") return "DEA";
        if(rowData?._children?.length > 0){           
            if(new Date(rowData?._children[0]?.next_training_date) < new Date()){
                return "NOK";
            }
            return "OK"
        }
        else if(new Date(rowData?.initial_date) > new Date()){
          return "OK";
        }
        else return "NOK";
      }

    function ExpirationFormatter(props) {
      const rowData = props.cell.getRow().getData();
      const parent = props.cell.getRow()?.getTreeParent();
      let bucket = '';
      if (!parent) {
        if (rowData?.deactivation_date != null && rowData?.deactivation_date !== '') bucket = 'DEA';
        else if (rowData?._children?.length > 0) {
          if (new Date(rowData._children[0]?.next_training_date) < new Date()) bucket = '0-';
          else if (new Date(rowData._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 15))) bucket = '15-';
          else if (new Date(rowData._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 30))) bucket = '30-';
          else if (new Date(rowData._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 45))) bucket = '45-';
          else if (new Date(rowData._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 60))) bucket = '60-';
          else bucket = '61+';
        } else if (new Date(rowData?.initial_date) > new Date()) bucket = '';
        else bucket = '0-';
      }
      if (bucket === '') return '';
      const module_settings = state?.module_settings || [];
      const color = getTrngSemaforColor(module_settings, bucket);
      const colorClass = getSemaforColorClass(color);

      return (
        <span className="inline-flex items-center gap-1.5">
          <span className={`inline-block w-2.5 h-2.5 rounded-full shrink-0 ${colorClass}`} title={bucket} />
          <span>{bucket}</span>
        </span>
      );
    }

    function InvitationFormatter(props) {
      const rowData = props.cell.getRow().getData();
      if (rowData?._children != null) {
        return rowData.custom_invitation ?? '';
      }
      return '';
    }

    function nameHeaderFilter(headerValue, rowValue, rowData, filterParams){
      if (!headerValue || String(headerValue).trim() === '') return true;
      const name = String(rowData?.training?.name ?? rowValue ?? '').trim();
      return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function trainingDepartmentHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || String(headerValue).trim() === '') return true;
      const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
      if (selected.length === 0) return true;
      const name = String(rowData?.training?.department?.name ?? rowValue ?? '').trim();
      if (!name) return false;
      const norm = normalizeForMatch(name);
      return selected.some(s => normalizeForMatch(s) === norm);
    }

    function companyNameHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || String(headerValue).trim() === '') return true;
      const name = String(rowData?.company?.name ?? rowValue ?? '').trim();
      return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function trainingEmployeeNameHeaderFilter(headerValue, rowValue, rowData) {
      if (!headerValue || String(headerValue).trim() === '') return true;
      const name = String(rowData?.training?.employee?.name ?? rowValue ?? '').trim();
      return normalizeForMatch(name).includes(normalizeForMatch(headerValue));
    }

    function dateToSearchableString(dateVal) {
      if (dateVal == null || dateVal === '') return '';
      const raw = String(dateVal).trim();
      let formatted = '';
      const dtISO = DateTime.fromISO(dateVal);
      if (dtISO.isValid) {
        formatted = dtISO.toFormat(dateFmt);
      } else {
        const dtDMY = DateTime.fromFormat(raw, dateFmt);
        if (dtDMY.isValid) formatted = dtDMY.toFormat(dateFmt);
      }
      return [formatted, raw].filter(Boolean).join(' ');
    }

    function dateHeaderFilter(headerValue, rowValue, rowData, filterParams){
      if (!headerValue || String(headerValue).trim() === '') return true;
      const hv = String(headerValue).trim().toLowerCase();
      if (filterParams.name === "last_training_date") {
        const lastDate = rowData?._children?.[0]?.last_training_date ?? rowData?.last_training_date;
        if (!lastDate) {
          const label = new Date(rowData?.initial_date) > new Date() ? t('TrainingStateList.Text.naplanovane') : t('TrainingStateList.Text.neskoleny');
          return label.includes(hv);
        }
        const searchable = dateToSearchableString(lastDate).toLowerCase();
        return searchable.includes(hv);
      }
      if (filterParams.name === "next_training_date") {
        const nextDate = rowData?._children?.[0]?.next_training_date ?? rowData?.next_training_date;
        if (!nextDate) {
          const label = new Date(rowData?.initial_date) > new Date() ? t('TrainingStateList.Text.naplanovane') : t('TrainingStateList.Text.neskoleny');
          return label.includes(hv);
        }
        const searchable = dateToSearchableString(nextDate).toLowerCase();
        return searchable.includes(hv);
      }
      if (rowData?._children?.length === 0) {
        if (new Date(rowData?.initial_date) > new Date()) return t('TrainingStateList.Text.naplanovane').includes(hv);
        return t('TrainingStateList.Text.neskoleny').includes(hv);
      }
      return false;
    }

    function getExpirationState(rowData) {
      if ((rowData?.deactivation_date != null && rowData?.deactivation_date !== "") || (rowData?.employee?.date_of_departure != null && rowData?.employee?.date_of_departure !== "")) return "DEA";
      if (rowData?._children?.length > 0) {
        const next = rowData._children[0]?.next_training_date;
        if (!next) return "";
        const d = new Date(next);
        const now = new Date();
        if (d < now) return "0-";
        const d15 = new Date(now); d15.setDate(now.getDate() + 15);
        const d30 = new Date(now); d30.setDate(now.getDate() + 30);
        const d45 = new Date(now); d45.setDate(now.getDate() + 45);
        const d60 = new Date(now); d60.setDate(now.getDate() + 60);
        if (d <= d15) return "15-";
        if (d <= d30) return "30-";
        if (d <= d45) return "45-";
        if (d <= d60) return "60-";
        return "61+";
      }
      if (new Date(rowData?.initial_date) > new Date()) return "";
      return "0-";
    }

    function expirationHeaderFilter(headerValue, rowValue, rowData, filterParams){
        if (!headerValue || String(headerValue).trim() === '') return true;
        const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
        if (selected.length === 0) return true;
        if (selected.some(s => s === "Všetko")) return true;
        const state = getExpirationState(rowData);
        if (state === "") return false;
        return selected.some(s => s.toUpperCase() === state.toUpperCase());
    }

    function invitationHeaderFilter(headerValue, rowValue, rowData, filterParams){
      if (!headerValue || String(headerValue).trim() === '') return true;
      const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
      if (selected.length === 0) return true;
      const rowState = (rowData?.custom_invitation ?? '').toString().trim();
      return selected.some(s => s.toUpperCase() === rowState.toUpperCase());
    }

  function stateHeaderFilter(headerValue, rowValue, rowData, filterParams){
      if (!headerValue || String(headerValue).trim() === '') return true;
      const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
      if (selected.length === 0) return true;
      let state = "";
      if(rowData?._children?.length > 0){
          if(new Date(rowData?._children[0]?.next_training_date) < new Date()) state="NOK";
          else state="OK";
      } else if(new Date(rowData?.initial_date) > new Date()) state="OK";
      else state="NOK";
      if((rowData?.deactivation_date!=null && rowData?.deactivation_date!=="") || (rowData?.employee?.date_of_departure!=null && rowData?.employee?.date_of_departure!=="")) state="DEA";
      return selected.some(s => s.toUpperCase() === state.toUpperCase());
  }

  function TrainingStatusFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const s = rowData?.training?.status == null || rowData?.training?.status === '' ? 'Aktívny' : rowData?.training?.status;
    const label = s === 'Zrušený' ? t('Common.Deactivated') : t('Common.ActivePlural');
    return <span className={s === 'Zrušený' ? 'text-red-600' : ''}>{label}</span>;
  }

  function trainingStatusHeaderFilter(headerValue, rowValue, rowData, filterParams) {
    if (!headerValue || String(headerValue).trim() === '') return true;
    const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
    if (selected.length === 0) return true;
    const rowLabel = (rowData?.deactivation_date != null && rowData?.deactivation_date !== '') ? t('Common.Deactivated') : t('Common.ActivePlural');
    return selected.includes(rowLabel);
  }

  function Status(props) {
    const rowData = props.cell.getRow().getData();
    if(rowData?.employee?.date_of_departure=="" || rowData?.employee?.date_of_departure==null) return "Aktívny";
    else return t('Common.Inactive');
  }

  function statusHeaderFilter(headerValue, rowValue, rowData, filterParams){
    if (!headerValue || String(headerValue).trim() === '') return true;
    const selected = String(headerValue).split(',').map(s => s.trim()).filter(Boolean);
    if (selected.length === 0) return true;
    const state = (rowData?.employee?.date_of_departure == null || rowData?.employee?.date_of_departure === '') ? 'Aktívny' : t('Common.Inactive');
    return selected.some(s => s.toUpperCase() === state.toUpperCase());
  }

  function machineHeaderFilter(headerValue, rowValue, rowData, filterParams){
    if(rowData.machines?.length<0)return false;
    else return rowData.machines.map(machine => machine?.name).join('/').toLowerCase().includes(headerValue.toLowerCase());
  }

  function MachineFormatter(props){
    const rowData = props.cell.getRow().getData();
    return rowData.machines?.map(machine => machine?.name)?.join('/');
  }

  function lecturerHeaderFilter(headerValue, rowValue, rowData, filterParams){
    return rowData.lecturer?.name.toLowerCase().includes(headerValue.toLowerCase()) || rowData.company_contact?.lecturer?.name.toLowerCase().includes(headerValue.toLowerCase());
  }

  function LecturerFormatter(props){
    const rowData = props.cell.getRow().getData();
    return rowData?.lecturer?.name || rowData?.company_contact?.lecturer?.name;
  }

  function contactHeaderFilter(headerValue, rowValue, rowData, filterParams){
    return rowData?.company_contact?.name.toLowerCase().includes(headerValue.toLowerCase()) || rowData?.company_contact?.employee?.name.toLowerCase().includes(headerValue.toLowerCase());
  }

  function ContactFormatter(props){
    const rowData = props.cell.getRow().getData();
    return rowData?.company_contact?.name || rowData?.company_contact?.employee?.name;
  }

  function viewFile(file_id){
      getRequest(`/api/training_records/protocol/${file_id}`).then((response) => {
          const d = response.data;
          if (d?.url) openFilePreview({ url: d.url, filename: d.filename || 'súbor' });
      });
  }

  function Protocol(props) {
      const rowData = props.cell.getRow().getData();
      if(rowData?._children?.length > 0){   
          if(rowData?._children[0]?.files)return <div className='flex flex-row'>{rowData?._children[0]?.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div>
      }
      return rowData.files ? <div className='flex flex-row'>{rowData.files.map((img) => (<a style={{color:'blue',cursor:'pointer',marginBottom:'2px',width: '24px',display: 'block'}} onClick={() => {viewFile(img.id);}}><PaperClipIcon/></a>))}</div> : null;
  }


  function auditDateText(raw) {
    if (raw == null || raw === '') return '';
    try {
      const dt = DateTime.fromISO(String(raw));
      if (dt.isValid) return dt.toFormat(`${dateFmt} HH:mm`);
    } catch (_e) {}
    return String(raw);
  }
  function CreatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    // Parent TrainingCard audit; child TrainingRecord uses own timestamps when training_card_id present
    const isChild = rowData?.training_card_id > 0;
    const text = auditDateText(isChild ? rowData?.created_at : rowData?.created_at);
    const user = isChild ? (rowData?.created_by_user || rowData?.createdByUser) : (rowData?.created_by_user || rowData?.createdByUser);
    if (!text && !user) return '';
    // Canonical contract: display-name string (not user object) — matches TrainingEmployeeList / tabulatorAuditColumns.
    const name = user?.employee?.name || user?.username || '';
    const initials = getUserInitials?.(name) || (name ? name.slice(0, 2).toUpperCase() : '');
    return (
      <div className="flex items-center gap-2">
        {user ? <Avatar label={initials} shape="circle" style={{ backgroundColor: getUserColor?.(user?.username) || '#64748b', color: '#fff' }} /> : null}
        <span>{[name, text].filter(Boolean).join(' ')}</span>
      </div>
    );
  }
  function UpdatedAtFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const isChild = rowData?.training_card_id > 0;
    const text = auditDateText(rowData?.updated_at);
    const user = rowData?.updated_by_user || rowData?.updatedByUser;
    if (!text && !user) return isChild ? '' : '';
    const name = user?.employee?.name || user?.username || '';
    const initials = getUserInitials?.(name) || (name ? name.slice(0, 2).toUpperCase() : '');
    return (
      <div className="flex items-center gap-2">
        {user ? <Avatar label={initials} shape="circle" style={{ backgroundColor: getUserColor?.(user?.username) || '#64748b', color: '#fff' }} /> : null}
        <span>{[name, text].filter(Boolean).join(' ')}</span>
      </div>
    );
  }

    const [columns,setColumns] = useState([
        // Tabulator 5.5.2: first non-frozen column flips later frozen cols to RIGHT.
        // Keep hidden id frozen and a single frozen editor so rowSelection stays LEFT-frozen with the tree column.
        { title: '', field: 'id', visible:false, frozen:true, print:false },
        { field: 'rowSelection', formatter:"rowSelection", titleFormatter:"rowSelection", titleFormatterParams:{rowRange:"active"}, hozAlign:"center", width: 44, minWidth: 44, headerSort:false, resizable:false, frozen: true, print:false, download:false,
          cellClick: function(e, cell) {
            cell.getRow().toggleSelect();
          }
        },
        { title: '', field: 'editor', hozAlign:'center', width: 44, minWidth: 44, headerSort:false, resizable:false, frozen: true, print:false, download:false, visible:false },
        { title: t('Common.EmployeeName'), field: 'employee.name', formatter: reactFormatter(<NameFormatter/>), headerFilter: "input", headerFilterFunc: employeeHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: t('Common.TrainingDepartment'), field: 'training.department.name', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: (state.departments || []).map(d => ({ label: d.name, value: d.name })), placeholder: t('Common.TrainingDepartment') }, headerFilterFunc: trainingDepartmentHeaderFilter, minWidth: 200, widthGrow: 2 },
        { title: t('Common.TrainingName'), field: 'custom_training_name',minWidth: 250,widthGrow:3,headerFilter:"input",headerFilterFunc:nameHeaderFilter,formatter: reactFormatter(<TrainingName/>)},
        { title: t('Common.LastTraining'), field: 'custom_last_training_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"last_training_date"},minWidth: 200,widthGrow:1,formatter: reactFormatter(<LastTrainingDate/>)},
        { title: t('Common.NextTraining'), field: 'custom_next_training_date',headerFilter:"input",headerFilterFunc:dateHeaderFilter,headerFilterFuncParams:{name:"next_training_date"},minWidth: 180,widthGrow:1,formatter: reactFormatter(<NextTrainingDate/>)},
        { title: t('Common.Protocol'), field: 'protocol', headerFilter: "input", minWidth: 200, widthGrow: 2, formatter: reactFormatter(<Protocol/>) },
        { title: t('Common.Expiration'), field: 'custom_expiration', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { placeholder: t('Common.Expiration'), exclusiveValues: ["Všetko"], options: [{ label: t('Common.All'), value: "Všetko" }, { label: '61+', value: '61+' }, { label: '60-', value: '60-' }, { label: '45-', value: '45-' }, { label: '30-', value: '30-' }, { label: '15-', value: '15-' }, { label: '0-', value: '0-' }, { label: 'DEA', value: 'DEA' }] }, headerFilterFunc: expirationHeaderFilter, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<ExpirationFormatter/>) },
        { title: t('Common.Status'), field: 'custom_state', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'OK', value: 'OK' }, { label: 'NOK', value: 'NOK' }, { label: 'DEA', value: 'DEA' }], placeholder: t('Common.Status') }, headerFilterFunc: stateHeaderFilter, minWidth: 150, widthGrow: 1, formatter: reactFormatter(<StateFormatter/>) },
        { title: t('Common.EmployeeStatus'), field: 'my_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: 'Aktívny', value: 'Aktívny' }, { label: t('Common.Inactive'), value: 'Neaktívny' }], placeholder: t('Common.EmployeeStatus') }, headerFilterFunc: statusHeaderFilter, formatter: reactFormatter(<Status/>), minWidth: 150, widthGrow: 1 },
        { title: t('Common.TrainingStatus'), field: 'custom_training_status', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: t('Common.ActivePlural'), value: "Aktívne" }, { label: t('Common.Deactivated'), value: "Deaktivované" }], placeholder: t('Common.TrainingStatus') }, headerFilterFunc: trainingStatusHeaderFilter, formatter: reactFormatter(<TrainingStatusFormatter/>), minWidth: 200, widthGrow: 1 },
        { title: t('TrainingStateList.Text.Pozvanka'), field: 'custom_invitation', headerFilter: primeMultiSelectHeaderFilter, headerFilterParams: { options: [{ label: t('TrainingInvitationList.Status.Active'), value: 'Aktívna' }, { label: t('Common.InvitationInactive'), value: 'Neaktívna' }, { label: t('TrainingStateList.Text.Ziadna'), value: 'Žiadna' }], placeholder: t('TrainingStateList.Text.Pozvanka') }, headerFilterFunc: invitationHeaderFilter, minWidth: 200, widthGrow: 1, formatter: reactFormatter(<InvitationFormatter/>) },
        { title: t('TrainingTypeList.Column.Type'), field: 'training.type', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: t('SummaryEmailOTKList.Column.Interval'), field: 'training.interval', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: t('Common.TrainingCompanyShort'), field: 'company.name', headerFilter: "input", headerFilterFunc: companyNameHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: t('Common.Machine'), field: 'machines', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<MachineFormatter/>), headerFilterFunc: machineHeaderFilter },
        { title: t('Common.Lecturer'), field: 'custom_lecturer_name', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<LecturerFormatter/>), headerFilterFunc: lecturerHeaderFilter },
        { title: t('Common.Trainer'), field: 'custom_company_contact_name', headerFilter: "input", minWidth: 200, widthGrow: 1, formatter: reactFormatter(<ContactFormatter/>), headerFilterFunc: contactHeaderFilter },
        { title: t('Common.Column.Responsible'), field: 'training.employee.name', headerFilter: "input", headerFilterFunc: trainingEmployeeNameHeaderFilter, minWidth: 200, widthGrow: 1 },
        { title: t('TrainingStateList.Text.Popis_typu_skolenia'), field: 'training.description', headerFilter: "input", minWidth: 200, widthGrow: 1 },
        { title: t('Common.Description'), field: 'description', headerFilter: inputOnEnterHeaderFilter, headerFilterLiveFilter: false, minWidth: 200, widthGrow: 1 },
        { title: t('Common.Column.CreatedAt'), field: 'created_at', minWidth: tabulatorDateUserColumnMinWidth(t('Common.Column.CreatedAt')), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: `${dateFmt} HH:mm` }, formatter: reactFormatter(<CreatedAtFormatter/>), hozAlign: 'left' },
        { title: t('Common.Column.UpdatedAt'), field: 'updated_at', minWidth: tabulatorDateUserColumnMinWidth(t('Common.Column.UpdatedAt')), headerFilter: dateUserHeaderFilter, headerFilterLiveFilter: false, headerFilterParams: { dateFormat: dateFmt, dateTimeFormat: `${dateFmt} HH:mm` }, formatter: reactFormatter(<UpdatedAtFormatter/>), hozAlign: 'left' },
    ]);

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      extra.show_deactivated = showDeactivated ? '1' : '0';
      extra.show_inactive_employees = showInactiveEmployees ? '1' : '0';
      const search = String(submittedSearchValueRef.current || searchValue || '').trim();
      if (search !== '') {
        extra.toolbar_search = search;
        extra.filter_search = search;
      }
      if (preview_period && preview_segment) {
        const fromRaw = preview_period.dateFrom;
        const toRaw = preview_period.dateTo;
        extra.filter_preview_period_from = typeof fromRaw === 'string'
          ? fromRaw
          : (toLocalDateString(fromRaw instanceof Date ? fromRaw : new Date(fromRaw)) ?? '');
        extra.filter_preview_period_to = typeof toRaw === 'string'
          ? toRaw
          : (toLocalDateString(toRaw instanceof Date ? toRaw : new Date(toRaw)) ?? '');
        extra.filter_preview_segment = preview_segment;
      }
      if (preview && !preview_period) {
        extra.filter_custom_state = preview === 'others' ? 'OK' : 'OK,NOK';
        // Preview OK bucket is next_date > today+30 → list tokens 45-,60-,61+ (not 61+ alone).
        const expMap = { after: '0-', '15': '15-', '30': '30-', others: '45-,60-,61+' };
        if (expMap[preview]) extra.filter_custom_expiration = expMap[preview];
        // Match trainingPreviewStats CURRENT readiness universe (active def + non-departed).
        extra.filter_preview_current_readiness = '1';
      }
      const table = getTable();
      const tableReadyForParams = tableBuiltRef.current;
      let hf = [];
      if (tableReadyForParams) hf = table?.getHeaderFilters?.() ?? [];
      if (tableReadyForParams && hf.length) {
        hf.forEach(f => {
          if (f?.field == null) return;
          let v = f.value;
          if (v === undefined || v === null || String(v).trim() === '') return;
          if (f.field === 'custom_expiration') {
            v = normalizeExclusiveFilterCsv(v, [t('Common.All')]);
            if (!v) return;
          }
          extra[`filter_${f.field}`] = v;
        });
      } else if (!tableReadyForParams && !preview && !preview_period && state.user_mask_filters) {
        const maskRow = state.user_mask_filters.find(m => m.page === 'TrainingStateList');
        if (maskRow) {
          parseMaskFilters(maskRow.filters).forEach(f => {
            if (!f?.field) return;
            let v = f.value;
            if (v === undefined || v === null || String(v).trim() === '') return;
            if (f.field === 'custom_expiration') {
              v = normalizeExclusiveFilterCsv(v, [t('Common.All')]);
              if (!v) return;
            }
            extra[`filter_${f.field}`] = v;
          });
        }
      }
      let sortersFromTable = [];
      if (tableReadyForParams) sortersFromTable = table?.getSorters?.() ?? [];
      const hasSorters = Array.isArray(sortersFromTable) && sortersFromTable.length > 0;
      if (hasSorters) {
        const clean = cleanSorters(sortersFromTable);
        if (clean.length > 0) extra.sorters = JSON.stringify(clean);
      } else if (!tableReadyForParams && !preview && !preview_period) {
        // Align first ajax with Tabulator initialSort (mask sorters or employee.name ASC).
        const init = getTabulatorInitialSortUnlessMaskHasSorters({
          userMaskFilters: state.user_mask_filters,
          maskPage: 'TrainingStateList',
          skipMask: false,
          defaultSort: [{ column: 'employee.name', dir: 'asc' }],
        });
        if (init.length > 0) {
          extra.sorters = JSON.stringify(init.map((s) => ({ field: s.column, dir: s.dir })));
        }
      }
      if (!extra.sorters && (preview || preview_period)) {
        extra.sorters = JSON.stringify([{ field: 'employee.name', dir: 'asc' }]);
      }
      return extra;
    }, [getTable, state.user_mask_filters, pageSizePc, showDeactivated, showInactiveEmployees, searchValue, preview, preview_period, preview_segment]);

    const scrollToFirst = () => scrollToFirstUtil(getTable());
    const scrollUp = () => scrollUpUtil(getTable());
    const scrollDown = () => scrollDownUtil(getTable());
    const scrollToLast = () => scrollToLastUtil(getTable());

    function setMask(item,value){
      const columnVisible = {...columnsVisible};
        columnVisible[item] = value;
      const table = getTable();
      for(const val in columnVisible) {
        if(columnVisible[val]==false){
          table?.hideColumn?.(`${val}`);
        }
        else{
          table?.showColumn?.(`${val}`);
        }
      }
      setColumnsVisible(columnVisible);
      setTimeout(() => {
        getTable()?.redraw?.(true);
      }, 0);
    }
  
    const itemRenderer = (item, options) => (
      <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
          <span className={`${item.icon} text-primary`} />
          <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
          {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
      </a>
    );
  
    const [expandedKeys, setExpandedKeys] = useState({});
  
    const handleClickOutside = (event) => {
      if (overlayRef.current && !overlayRef.current.contains(event.target)) {
          setExpandedKeys({});
      }
    };
  
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    // Pusher: pri zmene záznamov školenia (vytvorenie/úprava/vymazanie) obnov progressive loading tabuľku
    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel) return;
        const refetch = () => refreshFromStart();
        channel.bind('training_record.created', refetch);
        channel.bind('training_record.updated', refetch);
        channel.bind('training_record.deleted', refetch);
        return () => {
            channel.unbind('training_record.created', refetch);
            channel.unbind('training_record.updated', refetch);
            channel.unbind('training_record.deleted', refetch);
        };
    }, [getTable]);

    const defaultColumnsVisibleStateList = { 'employee.name': true, 'training.department.name': true, custom_training_name: true, custom_last_training_date: true, custom_next_training_date: true, protocol: true, custom_expiration: true, custom_state: true, my_status: true, custom_training_status: true, custom_invitation: true, 'training.type': true, 'training.interval': true, 'company.name': true, 'machines': true, custom_lecturer_name: true, custom_company_contact_name: true, 'training.employee.name': true, 'training.description': true, description: true, created_at: true, updated_at: true };
    const resetMask = () => resetTabulatorMask({ page: 'TrainingStateList', defaultColumnsVisible: defaultColumnsVisibleStateList, ref, columns, setColumnsVisible });

      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
              ...(!preview && !preview_period ? [
              {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => { setUserMaskFilter("TrainingStateList", "set_filters", null, getTable()?.getHeaderFilters?.() ?? [], null); },
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                // clearHeaderFilter → Filter.refreshFilter → reloadData (Tabulator owns remote reload)
                command: () => { setUserMaskFilter("TrainingStateList", "set_filters", null, [], null); getTable()?.clearHeaderFilter?.(); },
                template: itemRenderer,
            },
              ] : []),
            {
                key: '0_3',
                label: t('Common.SetSorting'),
                icon: 'pi pi-sort-alt',
                command: () => { setUserMaskFilter("TrainingStateList", "set_sorters", null, null, null, cleanSorters(getTable()?.getSorters?.() ?? [])); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                // setSort([]) → Sort.refreshSort → reloadData (Tabulator owns remote reload)
                command: () => { setUserMaskFilter("TrainingStateList", "set_sorters", null, null, null, []); getTable()?.setSort?.([]); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            { key: '0_5b', label: t('Common.ResetUserMask'), icon: 'pi pi-refresh', command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); refreshFromStart(); }, template: itemRenderer },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('TrainingStateList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        const columnVisible = {...columnsVisible};
const table = getTable();
        for(let val in columnVisible) {
          if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
            columnVisible[val]=false;
            table?.hideColumn?.(`${val}`);
          }
        };
        setColumnsVisible(columnVisible);
        setTimeout(() => {
          getTable()?.redraw?.(true);
        }, 0);
    }


    const buildTrainingEmployeeExportQueryString = useCallback((opts = {}) => {
      const extra = {};
      const table = getTable();
      const hf = table?.getHeaderFilters?.() ?? [];
      hf.forEach((f) => {
        if (f?.field == null) return;
        let v = f.value;
        if (v === undefined || v === null || String(v).trim() === '') return;
        if (f.field === 'custom_expiration') {
          v = normalizeExclusiveFilterCsv(v, [t('Common.All')]);
          if (!v) return;
        }
        extra[`filter_${f.field}`] = v;
      });
      const sorters = cleanSorters(table?.getSorters?.() || []);
      if (sorters.length) extra.sorters = JSON.stringify(sorters);
      const search = String(submittedSearchValueRef.current || searchValue || '').trim();
      if (search) extra.toolbar_search = search;
      extra.show_deactivated = showDeactivated ? '1' : '0';
      extra.show_inactive_employees = showInactiveEmployees ? '1' : '0';
      return buildExportQueryStringFromParams(extra, opts);
    }, [getTable, searchValue, showDeactivated, showInactiveEmployees]);

    const runTrainingEmployeePrint = useCallback(async () => {
      try {
        setDialogText?.(t('Common.PreparingPrint'));
        setVisible?.(true);
        const suffix = buildTrainingEmployeeExportQueryString({ includePrintColumns: true });
        const html = await fetchTextGet(`/api/training_employees/export/print${suffix}`);
        if (!openPrintHtmlWindow(html)) {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Print'), detail: t('TrainingStateList.Text.Povolte_kontextove_okna'), life: 4000 });
        }
      } catch (e) {
        toast?.current?.show({ severity: 'error', summary: t('Common.Print'), detail: e?.message || t('TrainingStateList.Text.Tlac_zlyhala'), life: 4500 });
      } finally {
        setVisible?.(false);
      }
    }, [buildTrainingEmployeeExportQueryString, setDialogText, setVisible, toast]);

    const exportTrainingEmployeesXlsx = useCallback(async () => {
      try {
        setDialogText?.(t('Common.PreparingExport'));
        setVisible?.(true);
        const suffix = buildTrainingEmployeeExportQueryString({ includePrintColumns: true });
        const defaultXlsx = xlsxDownloadFilename('Skolenia podla stavu');
        const { blob, filename } = await downloadBlobGet(`/api/training_employees/export/xlsx${suffix}`, defaultXlsx);
        triggerBlobDownload(blob, filename || defaultXlsx);
      } catch (e) {
        toast?.current?.show({ severity: 'error', summary: t('Common.Export'), detail: e?.message || t('TrainingStateList.Text.Export_zlyhal'), life: 4500 });
      } finally {
        setVisible?.(false);
      }
    }, [buildTrainingEmployeeExportQueryString, setDialogText, setVisible, toast]);


    const exportToExcelLegacyUnused = () => {
        const excel_type = {};
        let error_records = (getTable()?.getData?.("active") ?? []).map((x) => {
        let id = x.id;
        let meno = x?.employee?.name;
        let oddelenie_skolenia = x?.training?.department?.name;
        let nazov_skolenia = x?.training?.name;
        let posledne_skolenie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.last_training_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let nasledujuce_skolenie = x?._children?.length > 0 ? DateTime.fromISO(x?._children[0]?.next_training_date).toFormat(dateFmt) : t('Common.NotPerformed');
        let expiracia = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="")expiracia = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_training_date) < new Date()){
                  expiracia="NOK";
              }
              else if(new Date(x?._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 15))){
                expiracia="15-";
              }
              else if(new Date(x?._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 30))){
                expiracia="30-";
              }
              else if(new Date(x?._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 45))){
                expiracia="45-";
              }
              else if(new Date(x?._children[0]?.next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 60))){
                expiracia="60-";
              }
              else expiracia="OK";
          }
          else expiracia="NOK";
        }
        let stav = "";
        if(x?.deactivation_date!=null && x?.deactivation_date!="") stav = "DEA";
        else{
          if(x?._children?.length > 0){           
              if(new Date(x?._children[0]?.next_training_date) < new Date()){
                  stav = "NOK";
              }
              else stav = "OK"
          }
          else stav = "NOK";
        }
        let status = "";
        if(x?.employee?.date_of_departure=="" || x?.employee?.date_of_departure==null) status = "Aktívny";
        else status = t('Common.Inactive');
        const pozvanka = x?.custom_invitation ?? "";
        let druh_skolenia = x?.training?.type;
        let interval = x?.training?.interval;
        let skoliaca_firma = x?.training?.training_company?.name;
        let skolitel = x?.training?.training_company_contact?.name;
        let zodpovedna_osoba = x?.training?.employee?.name;
        let popis_typu_skolenia = x?.training?.description;
        let popis = x?.description;
        return {
            id,meno,oddelenie_skolenia,nazov_skolenia,posledne_skolenie,nasledujuce_skolenie,expiracia,stav,status,pozvanka,
            druh_skolenia,interval,skoliaca_firma,skolitel,zodpovedna_osoba,popis_typu_skolenia,popis
    
        };
        }).sort((a, b) => (parseInt(a.specific_id) > parseInt(b.specific_id)) ? -1 : 1);
        const worksheet = XLSX.utils.json_to_sheet(error_records);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Skolenia podla stavu");
        const excelBuffer = XLSX.writeFile(workbook, "skolenia_podla_stavu.xlsx",{bookSST:true});//{ bookType: 'xlsx', type: 'array' });
      };

    const onSelectRow = (data, rows) => {
        setInvitationIcon(true);
        setInsertIcon(true);
        if(data.length>0){
            // Parent = riadok karty (TrainingCard): má _children alebo nemá training_card_id. Child = záznam školenia (TrainingRecord): má training_card_id > 0.
            let children = 0;
            let parent = 0;
            data.forEach(obj => {
                const hasChildren = obj._children !== undefined && Array.isArray(obj._children);
                const isChildRow = obj.training_card_id > 0;
                if (hasChildren || !isChildRow) {
                    parent++;
                } else {
                    children++;
                }
            });
            if(parent>0 && children==0){
                let training_ids = data.map(obj => obj.training_id);
                training_ids = training_ids.filter((item, index) => training_ids.indexOf(item) === index);
                if(training_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                let company_ids = data.map(obj => obj.company_id);
                company_ids = company_ids.filter((item, index) => company_ids.indexOf(item) === index);
                if(company_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                // Pri viacerých riadkoch vyžadujeme aspoň jeden spoločný stroj; pri jednom riadku nie
                if(data.length>1){
                    let machines = data.map(obj => (obj.machines || []).map(machine => machine.id));
                    let common_machines = machines.length ? machines.shift().filter(function(v) {
                      return machines.every(function(a) {
                          return a.indexOf(v) !== -1;
                      });
                    }) : [];
                    if(common_machines?.length<1){
                      setInvitationIcon(true);
                      return;
                    }
                }
                let lecturer_ids = data.map(obj => obj.lecturer_id);
                lecturer_ids = lecturer_ids.filter((item, index) => lecturer_ids.indexOf(item) === index);
                if(lecturer_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                let company_contact_ids = data.map(obj => obj.company_contact_id);
                company_contact_ids = company_contact_ids.filter((item, index) => company_contact_ids.indexOf(item) === index);
                if(company_contact_ids?.length>1){
                    setInvitationIcon(true);
                    return;
                }
                setInvitationIcon(false);
                setInsertIcon(!user?.permissions?.includes('add training'));
            }
            else {
                setInsertIcon(true);
            }
        }
        else {
            setInsertIcon(true);
        }
    };

    const validate = values => {
        const errors = {};
        return errors;
    };

    const formik = useFormik({
        initialValues:{
            training_id:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:'',employees:[]
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
          let invitation = {
            name:'',invitation_date: '',invitation_time:'',location:'',
            training_id:values.training_id,company_id:values.company_id,company_contact_id:values.company_contact_id,
            training: (trainingTypesList || []).find(t => t.id == values.training_id),
            lecturer_id: (companyContactsList || []).find(c => c.id == values.company_contact_id)?.lecturer_id,
            mail:true,sms:false,contact_notify:true,email_content:'',sms_content:'',
            notifications:"",employees:values.employees,machines:values.machines,
          };
          dispatch({type: 'create_new_tab', name: t('TrainingInvitationList.Tab.New'), translationKey: 'TrainingInvitationList.Tab.New', legacyLabel: t('TrainingInvitationList.Tab.New'),page:'TrainingInvitationAdd',props:{invitation: invitation,type:'add'},mask:'trng028'});
          setVisibleInvitation(false);
        }
    });

    function addNewTrainingRecord(){
        const data = ref?.current?.getSelectedData("active") ?? [];
        if (data.length === 0) {
            toast?.current?.show({ severity: 'warn', summary: t('Common.SelectRows'), detail: t('TrainingStateList.Text.Oznacte_aspon_jeden_riadok_iba_rodicovske_so_zho'), life: 4000 });
            return;
        }
        const first = data[0];
        const training = {
            training_id: first.training_id,
            company_id: first.company_id ?? '',
            machines: first.machines ?? [],
            lecturer_id: first.lecturer_id ?? '',
            company_contact_id: first.company_contact_id ?? '',
            employees: data.map(obj => obj.employee).filter(Boolean),
            last_training_date: '',
            description: first._children?.[0]?.description ?? '',
        };
        dispatch({ type: 'create_new_tab', name: t('TrainingStateList.Text.Nove_skolenie'), translationKey: 'TrainingStateList.Text.Nove_skolenie', legacyLabel: t('TrainingStateList.Text.Nove_skolenie'), page: 'TrainingRecordAdd', props: { training }, mask: 'trng012' });
    }

    function addNewInvitation(){
        const data = ref?.current?.getSelectedData("active");
        const contacts = companyContactsList || [];
        const openDialog = (contactsForDialog = contacts) => {
            setVisibleInvitation(true);
            const row = data[0];
            setInvitationSourceRow(row || null);
            const hydrated = buildTrainingCardEditFormValues(row);
            const result = computeTrainingSelectionCascade({
                companies: trainingCompanies,
                machines: state.machines || [],
                lecturerTypes: (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback,
                companyContacts: contactsForDialog,
                companyId: row?.company_id,
                machineIds: row?.machines,
                lecturerTypeId: row?.lecturer_id ?? row?.company_contact?.lecturer_id,
                companyContactId: row?.company_contact_id,
            });
            setMachines(result.availableMachines);
            setLecturers(result.availableLecturerTypes);
            setCompanyContacts(result.availableContacts);
            const cascaded = mergeTrainingCardCascadeFormValues(
                hydrated,
                toTrainingSelectionFormValues(result),
                { preserveHydrated: true },
            );
            formik.setValues({
                ...formik.values,
                training_id: row?.training_id,
                ...cascaded,
                employees: data.map(obj => obj.employee).filter(Boolean).map((employee) => ({name:employee.name,id:employee.id})),
            });
        };
        if (!contacts.length) {
            getRequest('/api/company_contacts').then((r) => {
                const list = r?.data ?? r ?? [];
                const filtered = Array.isArray(list) ? list.filter((c) => c?.module === 'training') : [];
                setCompanyContactsList(prev => (prev.length ? prev : filtered));
                openDialog(filtered);
            }).catch(() => openDialog([]));
        } else {
            openDialog();
        }
    }

    function applyListCascade(targetFormik, snapshot, extraValues = {}) {
        const result = computeTrainingSelectionCascade({
            companies: trainingCompanies,
            machines: state.machines || [],
            lecturerTypes: effectiveLecturers,
            companyContacts: companyContactsList,
            ...snapshot,
        });
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
        // Invitation dialog locks company/machines/lecturer; preserve hydrated IDs against remount/async noise.
        const preserveHydrated = Boolean(visibleInvitation);
        const cascaded = mergeTrainingCardCascadeFormValues(
            targetFormik.values,
            toTrainingSelectionFormValues(result),
            { preserveHydrated },
        );
        targetFormik.setValues({
            ...targetFormik.values,
            ...cascaded,
            ...extraValues,
        });
    }

    function changeCompany(company_id){
        const current = visibleInvitation ? formik : formikUpdate;
        applyListCascade(current, {
            companyId: company_id,
            machineIds: current.values?.machines,
            lecturerTypeId: current.values?.lecturer_id,
            companyContactId: current.values?.company_contact_id,
        }, { employees: [] });
    }

    function changeMachine(nextMachines){
        const current = visibleInvitation ? formik : formikUpdate;
        applyListCascade(current, {
            companyId: current.values?.company_id,
            machineIds: nextMachines,
            lecturerTypeId: current.values?.lecturer_id,
            companyContactId: current.values?.company_contact_id,
        }, { employees: [] });
    }

    function changeLecturer(lecturer_id){
        const current = visibleInvitation ? formik : formikUpdate;
        applyListCascade(current, {
            companyId: current.values?.company_id,
            machineIds: current.values?.machines,
            lecturerTypeId: lecturer_id,
            companyContactId: current.values?.company_contact_id,
        }, { employees: [] });
    }

    const formikUpdate = useFormik({
        initialValues: selectedRecord ? {
            id: selectedRecord?.id, training_id: selectedRecord?.training_id,
            last_training_date:selectedRecord?.last_training_date,description:selectedRecord?.description,
            company_id:selectedRecord?.company_id,
            machines:selectedRecord?.machines.map((machine) => ({name:machine.name,id:machine.id})),
            lecturer_id:selectedRecord?.company_contact?.lecturer_id,company_contact_id:selectedRecord?.company_contact_id} : 
            {training_id: '',last_training_date: '',description:'',company_id:'',machines:[],lecturer_id:'',company_contact_id:''},
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else formData.append(value, values[value] != null ? values[value] : "");
            }
            for(let i = 0;i<updatefileList.length;i++){
              //console.log("IMAGE :"+fileList[i].name);
              formData.append('files[]',updatefileList[i]);
            }
            postRequest(`/api/training_records/update/${formikUpdate.values.id}`, formData,true)
            .then((response) => {
                setVisibleRecord(false);
                formikUpdate.resetForm();
                if(updatefileList.length){
                  setUpdateFileList([]);
                  updateFileListRef.current.value = null;
                }
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                refreshFromStart();
            }).catch((reason) => {
                if(!navigator.online){
                    alert(t('ServiceTask.OfflineQueuedAlert'));
                }
                else{
                    alert(t('Common.Toast.ActionFailedDetail'));
                }
            });
        },
    });

    // HISTORICAL Preview period segmentation only (on_time/late in range).
    // Do NOT apply CURRENT-active employee/card gates — BE #105 HISTORICAL_KEEP
    // intentionally returns later-departed employees / later-deactivated cards.
    function periodSegmentFilter(data, filterParams) {
      const children = data._children || [];
      const dateFrom = filterParams.dateFrom instanceof Date ? filterParams.dateFrom : new Date(filterParams.dateFrom);
      const dateTo = filterParams.dateTo instanceof Date ? filterParams.dateTo : new Date(filterParams.dateTo);
      const wantOnTime = filterParams.segment === 'on_time';
      for (let i = 0; i < children.length; i++) {
        const rec = children[i];
        const last = rec.last_training_date ? new Date(rec.last_training_date) : null;
        if (!last || last < dateFrom || last > dateTo) continue;
        const next = rec.next_training_date ? new Date(rec.next_training_date) : null;
        const isOnTime = next && last <= next;
        if (isOnTime === wantOnTime) return true;
      }
      return false;
    }

    const invitationEditLecturers = useMemo(() => {
        if (!visibleInvitation || !invitationSourceRow) return lecturers;
        return buildEditFormLecturerOptions({
            cascadeLecturers: lecturers,
            companyContactsList,
            fullLecturers: effectiveLecturers,
            selectedCard: invitationSourceRow,
        });
    }, [visibleInvitation, invitationSourceRow, lecturers, companyContactsList, effectiveLecturers]);

    const invitationEditCompanyContacts = useMemo(() => {
        if (!visibleInvitation || !invitationSourceRow) return companyContacts;
        return buildEditFormCompanyContactOptions({
            cascadeContacts: companyContacts,
            companyContactsList,
            selectedCard: invitationSourceRow,
        });
    }, [visibleInvitation, invitationSourceRow, companyContacts, companyContactsList]);
    
    return(
        <>
        <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewTrainingRecord()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button type="button" onClick={() => runTrainingEmployeePrint()}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor !== "active" ? () => setVisibleSearch(true) : () => clearSearch()}>{searchIconColor === "" ? <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button type="button" onClick={() => exportTrainingEmployeesXlsx()}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button type="button" onClick={() => { captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="invite"><button className="disabled:opacity-25" disabled={invitationIcon} onClick={() => addNewInvitation()}><EnvelopeIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Print.Title.TrainingCompanyCertStateList'),"TrainingStateList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("TrainingStateList",columnsVisible,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
      </div>
      <div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    
    <div ref={elementRef}>
    <ReactTabulator
      onRef={(r) => (ref.current = r.current)}
      className='h-[calc(100vh_-_193px)]'
      columns={columns}
      events={{
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = getTable();
          if (!table) return;
          if (preview_period && preview_segment) {
            const dateFrom = new Date(preview_period.dateFrom);
            const dateTo = new Date(preview_period.dateTo);
            table.setFilter?.(periodSegmentFilter, { dateFrom, dateTo, segment: preview_segment });
            // Initial ajax may have started without period local filter — one safe refresh.
            refreshFromStart();
          } else if (previewHeaderFilters.length) {
            // UI-only: third arg true + isRestoring gate — must not become a second remote owner.
            // Population for CURRENT preview is owned by buildRequestParams only.
            isRestoringRef.current = true;
            try {
              previewHeaderFilters.forEach((f) => {
                table.setHeaderFilterValue?.(f.field, f.value, true);
              });
            } finally {
              setTimeout(() => { isRestoringRef.current = false; }, 0);
            }
          }
          const mask = state.user_mask_filters?.filter(m => m.page === "TrainingStateList") ?? [];
          if (mask.length > 0 && !preview && !preview_period) {
            // Layout/visibility only — header filters + sort come from initialHeaderFilter / initialSort
            // (Filter.tableBuilt applies them while tableInitialized=false → no remote restore reloads).
            const attributes = safeParse(mask[0].attributes, []);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) {
              table.setColumnLayout?.(attributes);
            }
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) {
                if (json_columns[column] === false) table.hideColumn?.(column);
                else table.showColumn?.(column);
              }
            }
            maskRestoreDoneRef.current = true;
          }
        },
        ...getTabulatorPersistLayoutEvents("TrainingStateList", ref, setUserMaskFilter),
        // Native Tabulator Filter.success / Sort.userSetSort already reloadData for remote mode.
        // Do not call replaceData / progressive soft-refresh here (events are also unreliable on 5.5.2).
        renderComplete: () => restoreHScroll(),
      }}
      options={{
        renderHorizontal: "virtual",
        rowHeight: TABULATOR_AUDIT_MIN_ROW_HEIGHT,
        layout: "fitColumns",
        movableColumns: true,
        headerSortTristate: true,
        ajaxURL: "/api/training_employees/paged",
        ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        dataLoader: true,
        dataLoaderLoading: t('Common.LoadingData'),
        dataLoaderError: t('Common.LoadFailed'),
        progressiveLoad: "scroll",
        progressiveLoadScrollMargin: 80,
        paginationSize: pageSizePc,
        filterMode: "remote",
        sortMode: "remote",
        pagination: false,
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (url, params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => {
          getTable()?.clearAlert?.();
        },
        dataTree: true,
        dataTreeStartExpanded: false,
        dataTreeFilter: false,
        dataTreeElementColumn: "employee.name",
        dataTreeCollapseElement: ReactDOMServer.renderToStaticMarkup(<CollapseTreeIcon/>),
        dataTreeExpandElement: ReactDOMServer.renderToStaticMarkup(<ExpandTreeIcon/>),
        dataTreeBranchElement: ReactDOMServer.renderToStaticMarkup(<BranchTreeIcon/>),
        printAsHtml: true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.TrainingStateList'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange: "active",
        initialHeaderFilter,
        initialSort,
      }}/>
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<3) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 
                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>    
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("TrainingStateList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
        <Dialog header={t('TrainingStateList.Text.Vytvorit_pozvanku')} visible={visibleInvitation} style={{ width: '40vw' }} onHide={() => { setVisibleInvitation(false); setInvitationSourceRow(null); }}
            onShow={() => {
                if (!trainingCardsList?.length) {
                    setLoadingInvitationCards(true);
                    getRequest("/api/training_cards").then((r) => {
                        setTrainingCardsList(r?.data ?? r ?? []);
                    }).catch(() => {}).finally(() => setLoadingInvitationCards(false));
                }
            }}>
            <form onSubmit={formik.handleSubmit}>
                <div>
                    <label
                        htmlFor="training_id"
                        className="block text-md font-semibold text-gray-800"
                    >
                        {t('Common.TrainingName')}
                    </label>
                    <select 
                    required
                    name="training_id"
                    disabled value={formik.values.training_id} 
                    className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                        <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                        {(trainingTypesList || []).map((training) => (
                        <option key={training.id} value={training.id}>{training.name}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label
                        htmlFor="company_id"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.TrainingCompanyShort')}</label>
                    <select required
                    name='company_id'
                    disabled
                    onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                    <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                    {trainingCompanies.map((training_company) => (
                        <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                    ))}
                    </select>
                </div> 
                {(formik.values?.company_id!="" && formik.values?.company_id!=null) && <><div>
                    <label
                        htmlFor="machines"
                        className="block text-md font-semibold text-gray-800"
                    >
                        Stroj*
                    </label>
                    <MultiSelect value={formik.values.machines} disabled onChange={(e) => changeMachine(e.value)}
                        options={machines.map((machine) => 
                            ({name:machine.name,id:machine.id})
                        )} 
                        optionLabel="name"
                        dataKey="id"
                        filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                    {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""}
                </div>
                {formik.values?.machines?.length > 0 && <><div>
                    <label
                        htmlFor="lecturer_id"
                        className="block text-md font-semibold text-gray-800"
                    >
                    Lektor
                    </label>
                    <select required
                    name='lecturer_id'
                    disabled onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                    <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                    {(invitationEditLecturers || lecturers).map((lecturer) => (
                        <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                    ))}
                    </select>
                </div>
                {(formik.values?.lecturer_id!="" && formik.values?.lecturer_id!=null) && <><div>
                    <label
                        htmlFor="company_contact_id"
                        className="block text-md font-semibold text-gray-800"
                    >{t('Common.Trainer')}</label>
                    <select required
                    name='company_contact_id'
                    onChange={formik.handleChange} value={formik.values?.company_contact_id}
                    className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                    <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                    {(invitationEditCompanyContacts || companyContacts).map((contact) => (
                        <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                    ))}
                    </select>
                </div>
                <div>
                <label
                    for="employees"
                    className="block text-md font-semibold text-gray-800"
                >
                    Zamestnanci
                </label>
                <MultiSelect required disabled value={formik.values.employees} onChange={(e) => formik.setFieldValue("employees",e.value)} 
                options={(trainingCardsList || []).filter(card => card.training_card?.filter(tr_card => tr_card.training_id == formik.values?.training_id)?.length > 0)
                    .filter(card => card.training_card.filter(tr_card => tr_card.training_id == formik.values?.training_id)[0]?.company_id == formik.values?.company_id && formik.values?.machines.map(machin => machin.id).every(obj => card.training_card.filter(tr_card => tr_card.training_id == formik.values?.training_id)[0]?.machines.map(machin => machin.id).includes(obj)) && formik.values?.lecturer_id == card?.training_card.filter(tr_card => tr_card.training_id == formik.values?.training_id)[0]?.lecturer_id ? card?.training_card.filter(tr_card => tr_card.training_id == formik.values?.training_id)[0]?.lecturer_id : card?.training_card.filter(tr_card => tr_card.training_id == formik.values?.training_id)[0]?.company_contact?.lecturer_id)
                    //.filter(card => card?.date_of_departure=="" || card?.date_of_departure==null)
                    .map((employee) => 
                    ({name:employee.name,id:employee.id})
                )} 
                optionLabel="name" 
                filter placeholder={loadingInvitationCards ? t('Common.LoadingEllipsis') : t('Common.SelectEmployees')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                {formik.errors.employees ? <div className="whitespace-pre-line" style={{color:'red'}}>{formik.errors.employees}</div> : null}
                <div>
                    <label className="block text-md my-2 font-semibold text-gray-800">POČET: {formik.values.employees.length}</label>
                </div>
                </div></>}</>}</>}                   
                <button type="submit" disabled={!formik.values?.company_contact_id || formik.values.employees.length<1} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Ui.R67.POKRACOVAT')}</button>         
            </form>
        </Dialog>
      </div> 
        </>
    )
}

/*function previewFilter(data, filterParams){
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    if(filterParams.time_period=="after"){

      if((data.employee.date_of_departure==null || data.employee.date_of_departure=="") && (data.deactivation_date==null || data.deactivation_date=="")){
        if((data._children.length == 0 || (data._children.length > 0 && new Date(data._children[0].next_training_date) < new Date()))){
          return true;
        }
      }
      }
      else if(filterParams.time_period=="15"){
        if((data.employee.date_of_departure==null || data.employee.date_of_departure=="") && (data.deactivation_date==null || data.deactivation_date=="")){
          if((data._children.length == 0 || (data._children.length > 0 && new Date(data._children[0].next_training_date) < new Date()))){
            return true;
          }
          if(data._children.length > 0 && ((new Date(data._children[0].next_training_date) > new Date()) && (new Date(data._children[0].next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 15))))){
            return true;
          }
        }
      }
      else if(filterParams.time_period=="30"){
        if((data._children.length == 0 || (data._children.length > 0 && new Date(data._children[0].next_training_date) < new Date()))){
          return true;
        }
        if((data.employee.date_of_departure==null || data.employee.date_of_departure=="") && (data.deactivation_date==null || data.deactivation_date=="")){
          if(data._children.length > 0 && ((new Date(data._children[0].next_training_date) > new Date()) && (new Date(data._children[0].next_training_date) <= new Date(new Date().setDate(new Date().getDate() + 30))))){//&& (new Date(data._children[0].next_training_date) > new Date(new Date().setDate(new Date().getDate() + 15))) 
            return true;
          }
        }  
      }
      else if(filterParams.time_period=="others"){
        if((data.employee.date_of_departure==null || data.employee.date_of_departure=="") && (data.deactivation_date==null || data.deactivation_date=="")){
          if((data._children.length == 0 || (data._children.length > 0 && new Date(data._children[0].next_training_date) < new Date()))){
            return false;
          }
          if(data._children.length > 0 && (new Date(data._children[0].next_training_date) > new Date(new Date().setDate(new Date().getDate() + 30)))){
            return true;
          }
        }    
      }
      return false;
    }*/